import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateVerificationStagesSmsSendingDate } from "@/services/api";

export interface UpdateVerificationStagesSmsSendingDateRequest {
  verificationStagesIds: number[];
  dateToSendSmsNotification: string;
  searchVerificationsRequestViewModel?: Record<string, unknown>;
  searchUnAssignedVerificationStagesRequestViewModel?: Record<string, unknown>;
}

export const useUpdateVerificationStagesSmsSendingDateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: UpdateVerificationStagesSmsSendingDateRequest) => {
      const response = await updateVerificationStagesSmsSendingDate(data);
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["verification-verify"],
      });
      await queryClient.invalidateQueries({
        queryKey: ["verification-donations"],
      });
    },
  });
};
